const blockOurMission = async($block) => {
	const { Swiper } = await import( 'swiper' );
	const { Navigation } = await import( 'swiper/modules' );
	await import( 'swiper/css/bundle' );

	const { gsap } = await import( 'gsap' );
	const { ScrollTrigger } = await import( 'gsap/ScrollTrigger' );
	gsap.registerPlugin( ScrollTrigger );

	const $section = $block;

	const valuesSlider = () => {
		const $sliderWrap = $('.section-mission-values');

		if ( !$sliderWrap.length ) { return false; }

		const $slider = $sliderWrap.find('.section-mission-values__inner');
		const $sliderNav = $sliderWrap.find('.section-mission-values__nav');
		const $buttonNext = $sliderWrap.find('.slider-nav__next');
		const $buttonPrev = $sliderWrap.find('.slider-nav__prev');
		const valuesSwiper = new Swiper($slider[0], {
			modules: [Navigation],
			init: false,
			slidesPerView: 1,
			speed: 600,
			simulateTouch: false,
			navigation: {
				nextEl: $buttonNext[0],
				prevEl: $buttonPrev[0]
			},
			breakpoints: {
				768: {
					slidesPerView: 3
				}
			}
		});

		const checkNavVisibility = () => {
			if (!valuesSwiper.isBeginning || !valuesSwiper.isEnd) {
				$sliderNav.css('display', 'flex');
			} else {
				$sliderNav.css('display', 'none');
			}
		};

		valuesSwiper.on('init', function() {
			checkNavVisibility();
		});

		valuesSwiper.on('slideChange', function() {
			const $images = $section.find('.section-mission__images');

			if ($images.length) {
				switchImage(this.realIndex);
			}
		});

		valuesSwiper.on('resize', function() {
			checkNavVisibility();
		});

		valuesSwiper.init();
	};

	const clickListener = () => {
		const $clickableValue = $section.find('.section-mission-value--clickable');

		if (!$clickableValue.length) { return false; }

		$clickableValue.on('click', (e) => {
			const $this = $(e.currentTarget);
			const num = $this.attr('data-num');

			switchImage(num);
		});
	};

	const switchImage = (num) => {
		$section.find('.section-mission__image')
			.removeClass('is-active')
			.filter('[data-num="' + num + '"]')
			.addClass('is-active');
	};

	const ourMissionImageParallax = () => {
		if ($('.wp-site-blocks').length) {
			gsap.to( $block.find('.section-mission__image .background-img'), {
				y: '18%',
				ease: 'none',
				scrollTrigger: {
					scroller: '.wp-site-blocks',
					trigger: $block,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true
				}
			} );
		}
	};

	valuesSlider();
	clickListener();
	ourMissionImageParallax();
};

themeUtils.loadBlock( blockOurMission, 'our-mission', '.section-mission' );
